/* Niroza 3D home section script (no external libraries).
   Settings (WhatsApp number, links, products) come from the section settings in the theme editor. */
(function () {
  "use strict";
  if (window.__nirozaHome) return;
  window.__nirozaHome = true;

  const doc = document;
  const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const FINE = matchMedia("(hover: hover) and (pointer: fine)").matches;
  // phones and tablets: lighter 3D drawing (a sharper canvas and finer label strips only on mouse devices)
  const LITE = !FINE;
  const STEP = LITE ? 2 : 1;
  const TAU = Math.PI * 2;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const damp = (a, b, k, dt) => lerp(a, b, 1 - Math.exp(-k * dt));
  const SPEC = {"ply":{"w":585,"h":1072,"cx":292.5,"r":283.5,"y0":322,"y1":981,"tw":1781,"th":554,"pad":48,"lw":1648,"glass":"rgb(40,18,10)","D":[0.056,0.056,0.056,0.324,0.743,0.884,0.835,0.796,0.785,0.778,0.797,0.798,0.793,0.799,0.804,0.798,0.795,0.8,0.801,0.792,0.785,0.788,0.791,0.791,0.798,0.813,0.839,0.876,0.91,0.94,0.959,0.974,0.979,0.974,0.971,0.972,0.974,0.977,0.972,0.963,0.962,0.978,0.982,0.984,0.997,1.0,0.997,0.995,0.999,0.998,0.984,0.972,0.947,0.918,0.893,0.874,0.851,0.835,0.848,0.835,0.817,0.826,0.822,0.796,0.779,0.775,0.576,0.21,0.042,0.04,0.04,0.04],"S":[[90,41,13],[90,41,13],[90,41,13],[69,33,11],[38,24,12],[28,24,17],[33,30,23],[37,33,28],[38,35,31],[40,37,32],[38,37,33],[38,37,33],[38,36,33],[37,36,32],[36,35,31],[37,35,31],[37,34,30],[36,34,29],[35,33,29],[35,32,28],[35,32,27],[34,31,26],[33,30,25],[33,29,24],[31,27,21],[29,25,18],[25,21,15],[21,18,11],[17,15,8],[14,11,5],[10,8,3],[7,6,2],[6,5,1],[6,5,1],[6,4,1],[5,3,1],[4,2,0],[3,2,0],[3,1,0],[3,1,0],[3,1,0],[1,0,0],[1,0,0],[1,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,1,1],[1,3,2],[3,6,5],[6,9,8],[10,12,10],[14,15,12],[17,17,14],[19,19,16],[22,21,17],[24,22,18],[23,23,19],[25,23,20],[27,24,20],[27,25,21],[28,26,22],[29,26,22],[29,26,21],[29,24,18],[44,26,14],[70,31,9],[81,32,6],[81,32,6],[81,32,6],[81,32,6]]},"b12":{"w":614,"h":1089,"cx":308.8,"r":288.8,"y0":320.0,"y1":1019.2,"tw":1814,"th":699,"pad":48,"D":[0.052,0.052,0.052,0.322,0.747,0.886,0.835,0.796,0.785,0.778,0.798,0.798,0.793,0.799,0.804,0.798,0.795,0.8,0.801,0.792,0.785,0.788,0.791,0.79,0.798,0.812,0.839,0.876,0.91,0.94,0.959,0.974,0.979,0.974,0.971,0.972,0.974,0.978,0.972,0.963,0.962,0.978,0.982,0.983,0.997,1.0,0.997,0.995,1.0,0.998,0.983,0.972,0.947,0.918,0.892,0.874,0.851,0.835,0.848,0.835,0.816,0.826,0.823,0.796,0.778,0.778,0.577,0.207,0.041,0.04,0.04,0.04],"S":[[16,103,100],[16,103,100],[16,103,100],[12,79,76],[13,43,43],[26,38,37],[43,51,49],[57,62,61],[64,68,66],[69,71,70],[70,70,69],[72,70,70],[73,71,72],[73,70,72],[73,70,70],[73,70,71],[73,71,71],[73,70,70],[73,70,70],[74,72,72],[74,73,73],[73,71,71],[72,70,70],[71,70,69],[67,68,66],[63,63,62],[55,56,55],[44,46,46],[33,37,35],[23,28,26],[15,21,20],[10,16,16],[7,13,13],[6,12,12],[5,12,11],[4,10,11],[4,9,9],[3,8,8],[3,8,7],[3,8,8],[3,7,7],[2,4,4],[2,3,4],[1,2,4],[1,0,0],[0,0,0],[0,0,1],[0,0,0],[0,0,0],[1,0,0],[2,3,3],[6,7,6],[13,13,12],[20,21,20],[28,28,27],[35,34,33],[42,40,39],[46,45,44],[51,45,45],[54,48,48],[56,52,52],[58,52,53],[59,53,54],[59,56,56],[56,56,55],[44,48,46],[25,53,50],[9,76,72],[4,90,84],[8,93,88],[8,93,88],[8,93,88]]},"sbt":{"w":480,"h":939,"cx":240.4,"r":236.4,"y0":292.8,"y1":875.2,"tw":1486,"th":582,"pad":48,"D":[0.056,0.056,0.056,0.324,0.743,0.884,0.835,0.796,0.785,0.778,0.797,0.798,0.793,0.799,0.804,0.798,0.795,0.8,0.801,0.792,0.785,0.788,0.791,0.791,0.798,0.813,0.839,0.876,0.91,0.94,0.959,0.974,0.979,0.974,0.971,0.972,0.974,0.977,0.972,0.963,0.962,0.978,0.982,0.984,0.997,1.0,0.997,0.995,0.999,0.998,0.984,0.972,0.947,0.918,0.893,0.874,0.851,0.835,0.848,0.835,0.817,0.826,0.822,0.796,0.779,0.775,0.576,0.21,0.042,0.04,0.04,0.04],"S":[[181,82,26],[181,82,26],[181,82,26],[139,67,22],[76,49,24],[56,49,34],[66,60,47],[74,67,57],[77,71,62],[80,74,65],[77,74,67],[77,74,66],[76,73,66],[75,72,65],[73,71,63],[74,70,62],[74,69,61],[72,68,59],[71,66,58],[71,65,57],[71,64,55],[69,62,53],[67,60,50],[66,58,48],[63,55,42],[58,50,37],[51,43,30],[42,36,23],[35,30,17],[28,23,11],[21,17,6],[15,13,4],[12,11,3],[12,10,3],[12,8,3],[10,7,2],[8,5,1],[6,4,0],[6,3,0],[7,3,0],[6,2,0],[3,1,0],[3,1,0],[2,1,0],[0,0,0],[0,0,0],[0,0,0],[1,1,1],[1,2,2],[3,6,5],[7,12,10],[12,18,16],[20,24,21],[28,30,25],[34,35,29],[39,39,32],[44,42,35],[48,45,37],[47,46,38],[50,47,40],[54,49,41],[55,50,43],[56,52,44],[58,53,44],[59,53,42],[59,49,36],[88,52,28],[140,62,19],[163,64,13],[162,64,13],[162,64,13],[162,64,13]]}};
  // where the flat label artwork sits on each bottle (fractions of the print file / label band)
  const WRAP = {
    b12: { thl: -41.7, thr: 44.7, xl: 273 / 703, xr: 430 / 703, bt: 33 / 874, bb: 842 / 874, ft: 11 / 256, fb: 244.5 / 256 },
    sbt: { thl: -46.4, thr: 41.5, xl: 275 / 703, xr: 430 / 703, bt: 32 / 728, bb: 694 / 728, ft: 11 / 256, fb: 244.5 / 256 }
  };

  /* ---------------- shared frame loop ---------------- */
  const S = { t: 0, dt: 1 / 60, sy: 0, vy: 0, mx: 0, my: 0, tmx: 0, tmy: 0, vw: innerWidth, vh: innerHeight };
  const tasks = new Set();
  let raf = 0, lastNow = 0, lastSy = null;
  // scroll position comes from the first Niroza content section (not the sticky header or the footer)
  const scrollRef = () => doc.querySelector("[data-nz-root]:not([data-nz-chrome])");
  function frame(now) {
    const dt = Math.min(0.05, Math.max(0.001, (now - lastNow) / 1000));
    lastNow = now;
    S.dt = dt; S.t += dt;
    // works whether the window or a theme wrapper (e.g. Horizon's .page-wrapper) is the scroller
    const ref = scrollRef();
    const pw = doc.querySelector(".page-wrapper");
    const sy = ref ? -ref.getBoundingClientRect().top : Math.max(scrollY, pw ? pw.scrollTop : 0);
    if (lastSy === null) lastSy = sy;
    S.vy = damp(S.vy, (sy - lastSy) / dt, 10, dt);
    lastSy = sy; S.sy = sy;
    S.mx = damp(S.mx, S.tmx, 4, dt);
    S.my = damp(S.my, S.tmy, 4, dt);
    S.vh = innerHeight; S.vw = innerWidth;
    tasks.forEach((f) => { try { f(S); } catch (err) { tasks.delete(f); console.error("[niroza]", err); } });
    raf = tasks.size ? requestAnimationFrame(frame) : 0;
  }
  function run(f) {
    if (tasks.has(f)) return;
    tasks.add(f);
    if (!raf && !doc.hidden) { lastNow = performance.now(); lastSy = null; raf = requestAnimationFrame(frame); }
  }
  function halt(f) { tasks.delete(f); }
  addEventListener("pointermove", (e) => { S.tmx = (e.clientX / innerWidth) * 2 - 1; S.tmy = (e.clientY / innerHeight) * 2 - 1; }, { passive: true });
  doc.addEventListener("visibilitychange", () => {
    if (doc.hidden) { cancelAnimationFrame(raf); raf = 0; }
    else if (tasks.size && !raf) { lastNow = performance.now(); lastSy = null; raf = requestAnimationFrame(frame); }
  });

  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6d2b79f5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  /* ---------------- per-section context (for the theme editor) ---------------- */
  function makeCtx(root) {
    const ctx = {
      root,
      tasks: new Set(), observers: [], listeners: [],
      q: (sel) => root.querySelector(sel),
      qa: (sel) => [...root.querySelectorAll(sel)],
      start(f) { ctx.tasks.add(f); run(f); },
      stop(f) { ctx.tasks.delete(f); halt(f); },
      inView(el, f, margin) {
        const io = new IntersectionObserver((es) => es.forEach((e) => (e.isIntersecting ? ctx.start(f) : ctx.stop(f))), { rootMargin: margin || "150px 0px" });
        io.observe(el);
        ctx.observers.push(io);
      },
      on(target, type, fn, opts) { target.addEventListener(type, fn, opts); ctx.listeners.push([target, type, fn, opts]); },
      destroy() {
        ctx.tasks.forEach((f) => halt(f));
        ctx.tasks.clear();
        ctx.observers.forEach((o) => o.disconnect());
        ctx.listeners.forEach(([t, ty, fn, o]) => t.removeEventListener(ty, fn, o));
      }
    };
    ctx.ro = "ResizeObserver" in window ? new ResizeObserver((es) => es.forEach((e) => e.target.__spin && e.target.__spin.resize())) : null;
    if (ctx.ro) ctx.observers.push(ctx.ro);
    return ctx;
  }

  /* ---------------- images (URLs come from CSS variables on the section) ---------------- */
  const imgCache = {};
  function img(ctx, name) {
    const v = getComputedStyle(ctx.root).getPropertyValue("--img-" + name);
    const m = v.match(/url\((['"]?)(.*?)\1\)/);
    if (!m) return Promise.reject(new Error("missing image " + name));
    return imgUrl(m[2]);
  }
  // an image by its URL (bottles whose photo and label come straight from the product, such as Playora)
  function imgUrl(url) {
    if (!imgCache[url]) {
      imgCache[url] = new Promise((res, rej) => {
        const i = new Image();
        i.decoding = "async";
        i.onload = () => res(i);
        i.onerror = rej;
        i.src = url;
      });
    }
    return imgCache[url];
  }

  /* ---------------- a new flat label (print file) wrapped for the 3D bottle ---------------- */
  const wrapCache = new Map();
  function wrapLabel(flat, s, w) {
    const key = flat.src + "|" + s.tw;
    if (wrapCache.has(key)) return wrapCache.get(key);
    const TW = s.tw, TH = s.th, pad = s.pad, FW = flat.naturalWidth, FH = flat.naturalHeight;
    const mid = doc.createElement("canvas");
    mid.width = FW; mid.height = TH;
    const m = mid.getContext("2d");
    m.imageSmoothingQuality = "high";
    [[0, w.bt * TH, 0, w.ft * FH], [w.bt * TH, w.bb * TH, w.ft * FH, w.fb * FH], [w.bb * TH, TH, w.fb * FH, FH]].forEach(([d0, d1, s0, s1]) => {
      if (d1 - d0 > 0.5 && s1 - s0 > 0.5) m.drawImage(flat, 0, s0, FW, s1 - s0, 0, d0, FW, d1 - d0);
    });
    const out = doc.createElement("canvas");
    out.width = TW + pad * 2; out.height = TH;
    const g = out.getContext("2d");
    g.imageSmoothingQuality = "high";
    const k = (360 - (w.thr - w.thl)) / ((1 - w.xr) + w.xl);
    const start = w.thl - w.xl * k;
    const segs = [[start, w.thl, 0, w.xl], [w.thl, w.thr, w.xl, w.xr], [w.thr, start + 360, w.xr, 1]];
    segs.forEach(([a, b, u0, u1]) => [-360, 0, 360].forEach((off) => {
      const c0 = ((a + off + 180) / 360) * TW + pad, c1 = ((b + off + 180) / 360) * TW + pad;
      if (c1 <= 0 || c0 >= TW + pad * 2) return;
      g.drawImage(mid, u0 * FW, 0, Math.max(1, (u1 - u0) * FW), TH, c0, 0, c1 - c0 + 0.6, TH);
    }));
    wrapCache.set(key, out);
    return out;
  }
  // a flat label (print file) laid round the bottle as one band, with dark glass in the gap (bottles whose spec has "lw")
  function flatTex(l, s) {
    const c = doc.createElement("canvas"), x = c.getContext("2d");
    c.width = s.tw + s.pad * 2; c.height = s.th;
    x.fillStyle = s.glass || "#000"; x.fillRect(0, 0, c.width, c.height);
    x.imageSmoothingQuality = "high";
    const x0 = s.tw / 2 - s.lw / 2 + s.pad;
    [-s.tw, 0, s.tw].forEach((o) => x.drawImage(l, x0 + o, 0, s.lw, s.th));
    return c;
  }
  const hasVar = (el, name) => /url\(/.test(getComputedStyle(el).getPropertyValue("--img-" + name));

  /* ---------------- 3D bottle spin: photo + unwrapped label ---------------- */
  class Spin {
    constructor(ctx, canvas) {
      this.c = canvas;
      this.key = canvas.dataset.spin;
      this.spec = SPEC[this.key];
      this.g = canvas.getContext("2d");
      this.box = canvas.parentElement;
      this.phi = 0; this.drawn = NaN; this.ready = false; this.k = 0;
      canvas.__spin = this;
      if (ctx.ro) ctx.ro.observe(canvas);
      const custom = WRAP[this.key] && hasVar(ctx.root, this.key + "-flat");
      const own = canvas.dataset.label ? imgUrl(canvas.dataset.label).then((f) => (this.spec.lw ? flatTex(f, this.spec) : f)) : null;
      const label = own || (custom
        ? img(ctx, this.key + "-flat").then((f) => wrapLabel(f, this.spec, WRAP[this.key])).catch(() => img(ctx, this.key + "-label"))
        : img(ctx, this.key + "-label"));
      Promise.all([canvas.dataset.photo ? imgUrl(canvas.dataset.photo) : img(ctx, this.key + "-photo"), label]).then(([p, l]) => {
        this.photo = p; this.label = l; this.ready = true;
        this.resize();
      }).catch(() => {});
    }
    resize() {
      if (!this.ready) return;
      const h = this.c.clientHeight;
      if (!h) return;
      const dpr = Math.min(window.devicePixelRatio || 1, LITE ? 1.5 : 2);
      const H = Math.round(h * dpr), k = H / this.spec.h, W = Math.round(this.spec.w * k);
      if (this.c.width !== W || this.c.height !== H) { this.c.width = W; this.c.height = H; }
      this.k = k;
      const s = this.spec, g = this.g, r = s.r * k, cx = s.cx * k;
      const x0 = cx - r * 0.985, x1 = cx + r * 0.985;
      this.gD = g.createLinearGradient(x0, 0, x1, 0);
      this.gS = g.createLinearGradient(x0, 0, x1, 0);
      const n = s.D.length;
      for (let i = 0; i < n; i++) {
        const t = i / (n - 1), d = Math.round(s.D[i] * 255), c = s.S[i];
        this.gD.addColorStop(t, "rgb(" + d + "," + d + "," + d + ")");
        this.gS.addColorStop(t, "rgb(" + c[0] + "," + c[1] + "," + c[2] + ")");
      }
      this.draw(this.phi, true);
      this.box.classList.add("nz-is-live");
    }
    draw(phi, force) {
      this.phi = phi;
      if (!this.ready || !this.k) return;
      if (!force && Math.abs(phi - this.drawn) < 0.0025) return;
      this.drawn = phi;
      const s = this.spec, k = this.k, g = this.g, label = this.label;
      g.globalCompositeOperation = "source-over";
      g.clearRect(0, 0, this.c.width, this.c.height);
      g.imageSmoothingEnabled = true;
      g.imageSmoothingQuality = "high";
      g.drawImage(this.photo, 0, 0, s.w * k, s.h * k);
      const cx = s.cx * k, r = s.r * k, y0 = s.y0 * k, dh = (s.y1 - s.y0) * k;
      const TP = s.tw / TAU;
      const xa = Math.ceil(cx - r * 0.985), xb = Math.floor(cx + r * 0.985);
      for (let x = xa; x < xb; x += STEP) {
        const nx = (x + STEP / 2 - cx) / r;
        const c = Math.sqrt(Math.max(0, 1 - nx * nx));
        let th = (Math.asin(nx) + phi + Math.PI) % TAU;
        if (th < 0) th += TAU;
        const su = Math.max(1, TP / (r * c)) * STEP;
        g.drawImage(label, th * TP + s.pad - su / 2, 0, su, s.th, x, y0, STEP + 0.4, dh);
      }
      g.globalCompositeOperation = "multiply";
      g.fillStyle = this.gD;
      g.fillRect(xa, y0, xb - xa, dh);
      g.globalCompositeOperation = "lighter";
      g.fillStyle = this.gS;
      g.fillRect(xa, y0, xb - xa, dh);
      g.globalCompositeOperation = "source-over";
    }
  }

  function setPouch(el, deg) {
    const v = deg.toFixed(1);
    if (el.__ry === v) return;
    el.__ry = v;
    const s = Math.sin((deg * Math.PI) / 180);
    el.style.setProperty("--ry", v + "deg");
    el.style.setProperty("--sx", (50 - s * 60).toFixed(1) + "%");
    el.style.setProperty("--sxb", (50 + s * 60).toFixed(1) + "%");
  }

  /* ---------------- links: WhatsApp / Amazon / Flipkart ---------------- */
  function initLinks(ctx, cfg) {
    const enc = encodeURIComponent;
    const products = cfg.products || {};
    const waNumber = String(cfg.whatsapp || "").replace(/\D/g, "");
    const linkFor = (kind, key) => {
      const p = key ? products[key] : null;
      if (kind === "whatsapp") {
        const msg = p
          ? "Hello Niroza, I would like to order " + p.name + ". Please share the price and delivery details."
          : "Hello Niroza, I would like to know more about your products.";
        return "https://wa.me/" + waNumber + "?text=" + enc(msg);
      }
      if (kind === "amazon") return (p && p.amazon) || (!p && cfg.amazonStore) || "https://www.amazon.in/s?k=" + enc(p ? p.search : "Niroza");
      if (kind === "flipkart") return (p && p.flipkart) || (!p && cfg.flipkartStore) || "https://www.flipkart.com/search?q=" + enc(p ? p.search : "Niroza");
      return "#";
    };
    ctx.qa("[data-buy]").forEach((a) => {
      a.href = linkFor(a.dataset.buy, a.dataset.product);
      a.target = "_blank";
      a.rel = "noopener";
    });
    const typed = ctx.q('[data-nz="typed"]');
    if (typed && products["vitamin-b12"]) {
      typed.textContent = "Hello Niroza, I would like to order " + products["vitamin-b12"].name + ". Please share the price and delivery details.";
    }
  }

  /* ---------------- intro loader ---------------- */
  function initIntro(ctx) {
    const root = doc.documentElement;
    const pre = doc.getElementById("nz-preloader");
    if (!pre) { root.classList.remove("nz-intro-pending"); return; }
    const count = pre.querySelector(".nz-preloader__count");
    const keys = ["logo-light", "b12-photo", "b12-label", "sbt-photo", "sbt-label", "dig-photo", "dig-back"];
    let loaded = 0;
    keys.forEach((k) => img(ctx, k).then(() => loaded++, () => loaded++));
    const t0 = performance.now(), MIN = 1150;
    let finished = false;
    const done = () => {
      if (finished) return;
      finished = true;
      pre.style.setProperty("--p", 1);
      if (count) count.textContent = "100";
      setTimeout(() => {
        pre.classList.add("nz-is-done");
        root.classList.remove("nz-intro-pending");
        try { sessionStorage.setItem("niroza-intro", "1"); } catch (e) {}
        setTimeout(() => pre.remove(), 1100);
      }, 120);
    };
    const step = (now) => {
      const tp = Math.min(1, (now - t0) / MIN);
      const p = Math.min(tp, 0.2 + (loaded / keys.length) * 0.8);
      pre.style.setProperty("--p", p.toFixed(3));
      if (count) count.textContent = String(Math.round(p * 100)).padStart(3, "0");
      if (p >= 1 || now - t0 > 3200) done();
      else requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  /* ---------------- floating capsules, leaves and berries ---------------- */
  function initFields(ctx) {
    const small = innerWidth < 700;
    const CONFIG = {
      "hero": { seed: 7, types: ["cap", "cap", "leaf", "berry", "drop"], far: small ? 5 : 9, mid: small ? 4 : 7, near: 0,
                zone: small ? (r) => [4 + r() * 92, 12 + r() * 26] : (r, L) => [L === 0 ? 30 + r() * 70 : 56 + r() * 42, 16 + r() * 72] },
      "hero-front": { seed: 19, types: ["cap", "leaf", "berry"], far: 0, mid: 0, near: small ? 2 : 3,
                zone: small ? (r) => [r() < 0.5 ? r() * 8 : 90 + r() * 8, 14 + r() * 22] : (r) => [r() < 0.35 ? r() * 6 : 88 + r() * 10, 18 + r() * 70] },
      "peaks": { seed: 31, types: ["berry", "berry", "leaf"], far: 0, mid: small ? 3 : 6, near: small ? 2 : 3,
                zone: (r) => [45 + r() * 55, 5 + r() * 70] },
      "page": { seed: 53, types: ["cap", "leaf", "berry", "drop"], far: small ? 4 : 7, mid: small ? 2 : 4, near: 0,
                zone: small ? (r) => [r() < 0.5 ? r() * 7 : 90 + r() * 8, 14 + r() * 76] : (r) => [48 + r() * 52, 20 + r() * 72] }
    };
    const LAYERS = [
      { cls: "nz-field__layer--far", depth: 0.25, scale: [0.45, 0.75] },
      { cls: "nz-field__layer--mid", depth: 0.6, scale: [0.8, 1.2] },
      { cls: "nz-field__layer--near", depth: 1.15, scale: [1.6, 2.4] }
    ];
    ctx.qa("[data-field]").forEach((el) => {
      const cfg = CONFIG[el.dataset.field];
      if (!cfg || el.children.length) return;
      const rnd = mulberry32(cfg.seed);
      const counts = [cfg.far, cfg.mid, cfg.near];
      const layers = [];
      LAYERS.forEach((L, li) => {
        if (!counts[li]) return;
        const layer = doc.createElement("div");
        layer.className = "nz-field__layer " + L.cls;
        for (let i = 0; i < counts[li]; i++) {
          const p = doc.createElement("i");
          p.className = "nz-pt nz-pt--" + cfg.types[Math.floor(rnd() * cfg.types.length)];
          const xy = cfg.zone(rnd, li);
          const r0 = Math.round(rnd() * 360);
          const st = p.style;
          st.setProperty("--x", xy[0].toFixed(1) + "%");
          st.setProperty("--y", xy[1].toFixed(1) + "%");
          st.setProperty("--s", (L.scale[0] + rnd() * (L.scale[1] - L.scale[0])).toFixed(2));
          st.setProperty("--dur", (7 + rnd() * 9).toFixed(1) + "s");
          st.setProperty("--delay", (-rnd() * 12).toFixed(1) + "s");
          st.setProperty("--ax", (rnd() * 2 - 1).toFixed(2));
          st.setProperty("--ay", (rnd() * 2 - 1).toFixed(2));
          st.setProperty("--r0", r0 + "deg");
          st.setProperty("--r1", (r0 + (60 + rnd() * 140) * (rnd() < 0.5 ? -1 : 1)).toFixed(0) + "deg");
          st.setProperty("--dx", ((rnd() * 2 - 1) * 34).toFixed(0) + "px");
          st.setProperty("--dy", ((rnd() * 2 - 1) * 46).toFixed(0) + "px");
          layer.appendChild(p);
        }
        el.appendChild(layer);
        layers.push({ el: layer, depth: L.depth });
      });
      if (REDUCED) return;
      ctx.inView(el, (s) => {
        const r = el.getBoundingClientRect();
        const prog = (r.top + r.height / 2 - s.vh / 2) / s.vh;
        for (const L of layers) {
          const tx = -s.mx * 28 * L.depth;
          const ty = -s.my * 18 * L.depth + prog * 110 * L.depth;
          L.el.style.transform = "translate3d(" + tx.toFixed(1) + "px," + ty.toFixed(1) + "px,0)";
        }
      });
    });
  }

  /* ---------------- hero turntable ---------------- */
  function initTurntable(ctx) {
    const el = ctx.q('[data-nz="turntable"]');
    if (!el) return;
    const stage = el.querySelector('[data-nz="tt-stage"]');
    const hero = ctx.q('[data-nz="hero"]');
    const items = [...el.querySelectorAll(".nz-tt__item")];
    const N = items.length;
    const spins = items.map((it) => { const c = it.querySelector("canvas[data-spin]"); return c ? new Spin(ctx, c) : null; });
    const pouches = items.map((it) => it.querySelector("[data-pouch]"));
    const words = [...el.querySelectorAll(".nz-tt__word span")];
    const dots = [...el.querySelectorAll(".nz-tt__dot")];
    const nameEl = el.querySelector('[data-nz="tt-name"]'), metaEl = el.querySelector('[data-nz="tt-meta"]'), linkEl = el.querySelector('[data-nz="tt-link"]');
    const INFO = [
      { name: "Vitamin B12", meta: "60 veg. capsules · 1000 mg per serving", href: "#nz-vitamin-b12", glow: "rgba(77,179,163,.55)" },
      { name: "Sea Buckthorn", meta: "60 veg. capsules · 1000 mg per serving", href: "#nz-sea-buckthorn", glow: "rgba(238,138,62,.5)" },
      { name: "Digest Powder", meta: "100 g pouch · Supports healthy digestion", href: "#nz-digest-powder", glow: "rgba(124,152,236,.46)" }
    ];
    // extra products (such as Playora) carry their caption on the slide itself
    items.forEach((it, i) => { if (it.dataset.ttName) INFO[i] = { name: it.dataset.ttName, meta: it.dataset.ttMeta || "", href: it.dataset.ttHref || "#", glow: it.dataset.ttGlow || "rgba(226,182,86,.5)" }; });
    const clocks = items.map(() => 3.9);
    const CYCLE = 11, TURN = 3.4;
    const cycle = (t) => {
      const u = ((t % CYCLE) + CYCLE) % CYCLE;
      if (u < TURN) { const x = u / TURN; return (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2) * TAU; }
      return Math.sin(((u - TURN) / (CYCLE - TURN)) * TAU) * 0.24;
    };
    let pos = 0, target = 0, dragging = false, startX = 0, startPos = 0, lastX = 0, lastT = 0, vel = 0;
    let active = -1, idleUntil = 0, lastAuto = 0, hovering = false;

    const setActive = (i) => {
      if (i === active) return;
      active = i;
      const info = INFO[i];
      const price = items[i].dataset.price;
      nameEl.textContent = info.name;
      metaEl.textContent = info.meta + (price ? " · " + price : "");
      linkEl.href = info.href;
      dots.forEach((d, j) => d.setAttribute("aria-current", String(j === i)));
      words.forEach((w, j) => w.classList.toggle("nz-is-on", j === i));
      stage.style.setProperty("--nz-glow", info.glow);
    };
    const nudge = () => { idleUntil = S.t + 8; ctx.start(task); };
    const go = (d) => { target = Math.round(target) + d; nudge(); };
    const goTo = (i) => {
      const cur = ((Math.round(target) % N) + N) % N;
      let d = i - cur;
      if (d > N / 2) d -= N;
      if (d < -N / 2) d += N;
      go(d);
    };
    ctx.on(el.querySelector('[data-tt="prev"]'), "click", () => go(-1));
    ctx.on(el.querySelector('[data-tt="next"]'), "click", () => go(1));
    dots.forEach((d) => ctx.on(d, "click", () => goTo(+d.dataset.ttGo)));
    ctx.on(el, "keydown", (e) => {
      if (e.key === "ArrowLeft") { go(-1); e.preventDefault(); }
      if (e.key === "ArrowRight") { go(1); e.preventDefault(); }
    });
    ctx.on(el, "pointerenter", () => { hovering = true; });
    ctx.on(el, "pointerleave", () => { hovering = false; });
    ctx.on(el, "focusin", () => { idleUntil = S.t + 12; });
    ctx.on(stage, "pointerdown", (e) => {
      if (e.button !== 0) return;
      dragging = true;
      startX = lastX = e.clientX; startPos = pos; lastT = performance.now(); vel = 0;
      stage.setPointerCapture(e.pointerId);
      stage.classList.add("nz-is-dragging");
      nudge();
    });
    ctx.on(stage, "pointermove", (e) => {
      if (!dragging) return;
      const w = stage.clientWidth || 1;
      pos = startPos - (e.clientX - startX) / (w * 0.55);
      const now = performance.now();
      vel = lerp(vel, (-(e.clientX - lastX) / (w * 0.55) / Math.max(1, now - lastT)) * 1000, 0.35);
      lastX = e.clientX; lastT = now;
    });
    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      stage.classList.remove("nz-is-dragging");
      target = Math.round(pos + clamp(vel * 0.18, -1, 1));
      nudge();
    };
    ctx.on(stage, "pointerup", endDrag);
    ctx.on(stage, "pointercancel", endDrag);

    const layout = () => {
      const w = stage.clientWidth;
      const R = Math.min(w * 0.34, 290);
      items.forEach((it, i) => {
        const a = ((i - pos) * TAU) / N;
        const c = Math.cos(a), sn = Math.sin(a);
        const depth = (1 - c) / 2;
        const tf = "translate3d(" + (sn * R).toFixed(1) + "px," + ((1 - c) * -R * 0.1).toFixed(1) + "px," + ((c - 1) * R * 0.95).toFixed(1) + "px)";
        if (it.__tf !== tf) { it.style.transform = tf; it.__tf = tf; }
        const f = depth < 0.03 ? "none" : (LITE ? "" : "blur(" + (depth * 2.6).toFixed(2) + "px) ") + "brightness(" + (1 - depth * 0.42).toFixed(3) + ")";
        if (it.__f !== f) { it.style.filter = f; it.__f = f; }
        const zi = String(Math.round(c * 100) + 100);
        if (it.style.zIndex !== zi) it.style.zIndex = zi;
      });
    };
    function task(s) {
      if (!dragging) pos = damp(pos, target, 5, s.dt);
      layout();
      setActive(((Math.round(pos) % N) + N) % N);
      items.forEach((it, i) => {
        const front = Math.pow((Math.cos(((i - pos) * TAU) / N) + 1) / 2, 3);
        if (!REDUCED) clocks[i] += s.dt * front;
        if (spins[i]) spins[i].draw(REDUCED ? 0 : cycle(clocks[i]));
        if (pouches[i]) setPouch(pouches[i], REDUCED ? 0 : (cycle(clocks[i]) * 180) / Math.PI);
      });
      if (!REDUCED && hero) {
        const hr = hero.getBoundingClientRect();
        const hp = clamp(-hr.top / Math.max(1, hr.height), 0, 1);
        const tf = hp < 0.001 ? "" : "translate3d(0," + (hp * 70).toFixed(1) + "px,0) rotateX(" + (hp * 18).toFixed(2) + "deg) scale(" + (1 - hp * 0.08).toFixed(3) + ")";
        if (stage.__tf !== tf) { stage.style.transform = tf; stage.__tf = tf; }
      }
      if (!REDUCED && !dragging && !hovering && s.t > idleUntil && s.t - lastAuto > 6.5) {
        lastAuto = s.t;
        target = Math.round(target) + 1;
      }
    }
    layout();
    setActive(0);
    ctx.inView(el, task, "0px");
  }

  /* ---------------- marquee ---------------- */
  function initMarquee(ctx) {
    if (REDUCED) return;
    ctx.qa(".nz-marquee__row").forEach((row) => {
      const track = row.querySelector(".nz-marquee__track");
      const dir = +row.dataset.dir || 1;
      let x = 0, w = 0;
      const measure = () => { w = track.firstElementChild.getBoundingClientRect().width; };
      measure();
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(measure);
      ctx.on(window, "resize", measure, { passive: true });
      ctx.inView(row, (s) => {
        if (!w) return;
        const speed = (46 + Math.min(Math.abs(s.vy) * 0.3, 900)) * dir;
        x = (x + speed * s.dt) % w;
        if (x < 0) x += w;
        const skew = clamp(-s.vy * 0.004, -8, 8);
        track.style.transform = "translate3d(" + (-x).toFixed(1) + "px,0,0) skewX(" + skew.toFixed(2) + "deg)";
      });
    });
  }

  /* ---------------- 3D tilt cards & magnetic buttons ---------------- */
  function initTilt(ctx) {
    if (!FINE || REDUCED) return;
    ctx.qa("[data-tilt]").forEach((card) => {
      ctx.on(card, "pointermove", (e) => {
        const r = card.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        card.classList.add("nz-is-tilting");
        card.style.setProperty("--ry", ((px - 0.5) * 16).toFixed(2) + "deg");
        card.style.setProperty("--rx", ((0.5 - py) * 11).toFixed(2) + "deg");
        card.style.setProperty("--gx", (px * 100).toFixed(1) + "%");
        card.style.setProperty("--gy", (py * 100).toFixed(1) + "%");
      });
      ctx.on(card, "pointerleave", () => {
        card.classList.remove("nz-is-tilting");
        card.style.setProperty("--rx", "0deg");
        card.style.setProperty("--ry", "0deg");
      });
    });
    ctx.qa(".nz-magnet").forEach((b) => {
      ctx.on(b, "pointermove", (e) => {
        const r = b.getBoundingClientRect();
        b.style.transform = "translate(" + ((e.clientX - (r.left + r.width / 2)) * 0.16).toFixed(1) + "px," + ((e.clientY - (r.top + r.height / 2)) * 0.26).toFixed(1) + "px)";
      });
      ctx.on(b, "pointerleave", () => { b.style.transform = ""; });
    });
  }

  /* ---------------- closer look: sticky 3D stage ---------------- */
  function initStory(ctx) {
    const section = ctx.q('[data-nz="story"]');
    if (!section) return;
    const steps = [...section.querySelectorAll(".nz-step")];
    const stage = section.querySelector('[data-nz="story-stage"]');
    const order = ["b12", "sbt", "dig"];
    const stageObjs = [...stage.querySelectorAll(".nz-stage__obj")];
    const words = [...stage.querySelectorAll(".nz-stage__word span")];
    const ticks = [...stage.querySelectorAll(".nz-stage__progress li")];
    const stagePouch = stage.querySelector("[data-pouch]");
    const desk = matchMedia("(min-width: 981px)");
    let stageSpins = null, activeKey = "b12", dragPhi = 0, dragging = false, sx = 0, sPhi = 0;
    const mobile = steps.map((st) => ({
      media: st.querySelector(".nz-step__media"),
      canvas: st.querySelector(".nz-step__media canvas"),
      pouch: st.querySelector(".nz-step__media [data-pouch]"),
      spin: null, phi: Math.random() * 3
    }));
    const setActive = (key) => {
      if (key === activeKey) return;
      const iNew = order.indexOf(key);
      activeKey = key;
      stage.classList.remove("nz-p-b12", "nz-p-sbt", "nz-p-dig");
      stage.classList.add("nz-p-" + key);
      stageObjs.forEach((o) => {
        const i = order.indexOf(o.dataset.key);
        o.classList.toggle("nz-is-on", i === iNew);
        o.classList.toggle("nz-is-before", i < iNew);
      });
      words.forEach((w) => w.classList.toggle("nz-is-on", w.dataset.key === key));
      ticks.forEach((t) => t.classList.toggle("nz-is-on", t.dataset.key === key));
    };
    ctx.on(stage, "pointerdown", (e) => {
      if (e.button !== 0) return;
      dragging = true; sx = e.clientX; sPhi = dragPhi;
      stage.setPointerCapture(e.pointerId);
      stage.classList.add("nz-is-dragging");
    });
    ctx.on(stage, "pointermove", (e) => { if (dragging) dragPhi = sPhi + (e.clientX - sx) * -0.012; });
    const end = () => { dragging = false; stage.classList.remove("nz-is-dragging"); };
    ctx.on(stage, "pointerup", end);
    ctx.on(stage, "pointercancel", end);

    const deskTask = (s) => {
      if (!stageSpins) {
        stageSpins = {};
        stageObjs.forEach((o) => { const c = o.querySelector("canvas"); if (c) stageSpins[o.dataset.key] = new Spin(ctx, c); });
      }
      const mid = s.vh * 0.5;
      let best = null;
      for (const st of steps) {
        const r = st.getBoundingClientRect();
        const d = Math.abs(r.top + r.height / 2 - mid);
        if (!best || d < best.d) best = { st, d, p: clamp((mid - r.top) / r.height, 0, 1) };
      }
      setActive(best.st.dataset.key);
      if (!dragging) dragPhi *= Math.exp(-0.35 * s.dt);
      const phi = (best.p - 0.5) * Math.PI * 1.15 + dragPhi + (REDUCED ? 0 : Math.sin(s.t * 0.55) * 0.07);
      const sp = stageSpins[activeKey];
      if (sp) sp.draw(phi);
      if (activeKey === "dig" && stagePouch) setPouch(stagePouch, REDUCED ? 0 : -30 + clamp(best.p / 0.8, 0, 1) * 240 + dragPhi * 57.3);
    };
    const mobileTask = (s) => {
      for (const m of mobile) {
        const r = m.media.getBoundingClientRect();
        if (r.bottom < -40 || r.top > s.vh + 40) continue;
        if (m.canvas && !m.spin) m.spin = new Spin(ctx, m.canvas);
        const p = clamp((s.vh - r.top) / (s.vh + r.height), 0, 1);
        if (!REDUCED) m.phi += s.dt * 0.3;
        if (m.spin) m.spin.draw((p - 0.5) * Math.PI * 1.2 + m.phi);
        if (m.pouch) setPouch(m.pouch, REDUCED ? 0 : p * 300 - 60 + Math.sin(m.phi) * 8);
      }
    };
    ctx.inView(section, (s) => (desk.matches ? deskTask(s) : mobileTask(s)), "200px 0px");
  }

  /* ---------------- Himalaya scene: painted parallax layers ---------------- */
  function initPeaks(ctx) {
    const sec = ctx.q('[data-nz="peaks"]');
    if (!sec) return;
    const depthEls = [...sec.querySelectorAll("[data-depth]")];
    const ridges = [...sec.querySelectorAll("canvas[data-ridge]")];
    const branch = sec.querySelector("canvas[data-branch]");
    const RIDGE = [
      { frac: 0.66, top: 0.10, amp: 0.34, freq: 1.25, seed: 11, c0: "#DDE7E1", c1: "#86A39B", snow: 0.9, light: 0.16 },
      { frac: 0.54, top: 0.12, amp: 0.30, freq: 1.9, seed: 23, c0: "#9DBBB0", c1: "#557C70", snow: 0.45, light: 0.12 },
      { frac: 0.44, top: 0.16, amp: 0.26, freq: 2.6, seed: 37, c0: "#4F7B69", c1: "#2A5341", snow: 0, light: 0.08 },
      { frac: 0.33, top: 0.18, amp: 0.24, freq: 3.4, seed: 51, c0: "#1E4633", c1: "#0B2318", snow: 0, light: 0.05 }
    ];
    const makeNoise = (seed) => {
      const r = mulberry32(seed), P = 512, v = new Float32Array(P);
      for (let i = 0; i < P; i++) v[i] = r();
      return (x) => {
        const i = Math.floor(x), f = x - i, t = f * f * (3 - 2 * f);
        const a = v[((i % P) + P) % P], b = v[(((i + 1) % P) + P) % P];
        return a + (b - a) * t;
      };
    };
    const paintRidge = (cv, cfg) => {
      const w = Math.round(cv.clientWidth), h = Math.round(cv.clientHeight);
      if (!w || !h) return;
      cv.width = w; cv.height = h;
      const g = cv.getContext("2d");
      const n = makeNoise(cfg.seed);
      const ys = new Float32Array(Math.ceil(w / 2) + 2);
      for (let i = 0; i < ys.length; i++) {
        const u = ((i * 2) / w) * cfg.freq * 3.2;
        let v = 0, amp = 1, sum = 0, fr = 1;
        for (let o = 0; o < 6; o++) {
          const nv = n(u * fr + o * 13.7);
          v += (o < 2 ? 1 - Math.abs(nv * 2 - 1) : nv) * amp; sum += amp; amp *= 0.5; fr *= 2.1;
        }
        ys[i] = h * (cfg.top + (1 - v / sum) * cfg.amp * 1.6);
      }
      g.clearRect(0, 0, w, h);
      const grad = g.createLinearGradient(0, h * cfg.top, 0, h);
      grad.addColorStop(0, cfg.c0);
      grad.addColorStop(1, cfg.c1);
      g.beginPath();
      g.moveTo(0, h);
      for (let i = 0; i < ys.length; i++) g.lineTo(i * 2, ys[i]);
      g.lineTo(w, h);
      g.closePath();
      g.fillStyle = grad;
      g.fill();
      g.save();
      g.clip();
      const haze = g.createLinearGradient(0, h * cfg.top, 0, h * 0.9);
      haze.addColorStop(0, "rgba(214,230,222,0)");
      haze.addColorStop(1, "rgba(214,230,222," + (cfg.light * 1.6).toFixed(3) + ")");
      g.fillStyle = haze;
      g.fillRect(0, 0, w, h);
      if (cfg.snow) {
        let minY = h;
        for (let i = 0; i < ys.length; i++) minY = Math.min(minY, ys[i]);
        const sg = g.createLinearGradient(0, minY, 0, minY + h * 0.2);
        sg.addColorStop(0, "rgba(250,252,250," + cfg.snow + ")");
        sg.addColorStop(1, "rgba(250,252,250,0)");
        g.fillStyle = sg;
        g.fillRect(0, minY, w, h * 0.2);
      }
      g.restore();
      g.beginPath();
      for (let i = 0; i < ys.length; i++) (i ? g.lineTo(i * 2, ys[i]) : g.moveTo(0, ys[0]));
      g.strokeStyle = "rgba(255,238,200," + (cfg.light * 2.2).toFixed(3) + ")";
      g.lineWidth = 1.4;
      g.stroke();
    };
    const paintBranch = (cv) => {
      const w = Math.round(cv.clientWidth), h = Math.round(cv.clientHeight);
      if (!w || !h) return;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
      const g = cv.getContext("2d");
      g.setTransform(dpr, 0, 0, dpr, 0, 0);
      g.clearRect(0, 0, w, h);
      const rnd = mulberry32(77);
      const narrow = w < 700;
      const U = Math.min(h / 820, w / 900) * (narrow ? 1.25 : 1);
      const P0 = { x: w * 1.04, y: narrow ? h * 0.46 : h * 0.98 };
      const P1 = { x: w * (narrow ? 0.82 : 0.84), y: narrow ? h * 0.30 : h * 0.74 };
      const P2 = { x: w * (narrow ? 0.52 : 0.6), y: narrow ? h * 0.1 : h * 0.44 };
      const bez = (a, b, c, t) => ({ x: (1 - t) * (1 - t) * a.x + 2 * (1 - t) * t * b.x + t * t * c.x, y: (1 - t) * (1 - t) * a.y + 2 * (1 - t) * t * b.y + t * t * c.y });
      const leaf = (x, y, ang, len, wid) => {
        g.save();
        g.translate(x, y); g.rotate(ang);
        const lg = g.createLinearGradient(0, -wid, 0, wid);
        lg.addColorStop(0, "#9FB38F"); lg.addColorStop(0.5, "#5E7B58"); lg.addColorStop(1, "#C9D3BC");
        g.fillStyle = lg;
        g.beginPath();
        g.moveTo(0, 0);
        g.quadraticCurveTo(len * 0.45, -wid, len, 0);
        g.quadraticCurveTo(len * 0.45, wid, 0, 0);
        g.fill();
        g.strokeStyle = "rgba(235,240,225,.45)"; g.lineWidth = 0.8;
        g.beginPath(); g.moveTo(2, 0); g.lineTo(len * 0.92, 0); g.stroke();
        g.restore();
      };
      const berry = (x, y, r) => {
        const bg = g.createRadialGradient(x - r * 0.35, y - r * 0.4, r * 0.1, x, y, r);
        bg.addColorStop(0, "#FFE7AE"); bg.addColorStop(0.25, "#FBB24A"); bg.addColorStop(0.7, "#E9761F"); bg.addColorStop(1, "#A8420F");
        g.fillStyle = bg;
        g.beginPath(); g.ellipse(x, y, r, r * 1.12, rnd() * 0.6, 0, TAU); g.fill();
        g.fillStyle = "rgba(255,255,255,.55)";
        g.beginPath(); g.arc(x - r * 0.38, y - r * 0.42, r * 0.16, 0, TAU); g.fill();
      };
      const twigs = [];
      g.lineCap = "round";
      for (let i = 0; i < 60; i++) {
        const a = bez(P0, P1, P2, i / 60), b = bez(P0, P1, P2, (i + 1) / 60);
        g.strokeStyle = "#4A3A2C";
        g.lineWidth = lerp(16, 4, i / 60) * U;
        g.beginPath(); g.moveTo(a.x, a.y); g.lineTo(b.x, b.y); g.stroke();
      }
      [0.22, 0.4, 0.58, 0.74, 0.88].forEach((t, k) => {
        const a = bez(P0, P1, P2, t);
        const side = k % 2 ? 1 : -1;
        const ang = Math.atan2(P2.y - P0.y, P2.x - P0.x) + side * (0.55 + rnd() * 0.35);
        const len = (90 + rnd() * 90) * U;
        const b = { x: a.x + Math.cos(ang) * len, y: a.y + Math.sin(ang) * len };
        const c = { x: a.x + Math.cos(ang - side * 0.25) * len * 0.5, y: a.y + Math.sin(ang - side * 0.25) * len * 0.5 };
        g.strokeStyle = "#57452F"; g.lineWidth = lerp(6, 3, t) * U;
        g.beginPath(); g.moveTo(a.x, a.y); g.quadraticCurveTo(c.x, c.y, b.x, b.y); g.stroke();
        twigs.push({ a, b, c, ang });
      });
      const leafAlong = (p0, p1, p2, count, base) => {
        for (let i = 0; i < count; i++) {
          const t = 0.15 + (i / count) * 0.85;
          const p = bez(p0, p1, p2, t);
          const dir = Math.atan2(p2.y - p0.y, p2.x - p0.x);
          const side = i % 2 ? 1 : -1;
          leaf(p.x, p.y, dir + side * (0.7 + rnd() * 0.5) + Math.PI * (rnd() < 0.15 ? 1 : 0), (base + rnd() * 40) * U, (7 + rnd() * 3) * U);
        }
      };
      leafAlong(P0, P1, P2, 14, 70);
      twigs.forEach((tw) => leafAlong(tw.a, tw.c, tw.b, 7, 56));
      const cluster = (p, n, spread) => {
        for (let i = 0; i < n; i++) {
          const ang = rnd() * TAU, d = Math.sqrt(rnd()) * spread * U;
          berry(p.x + Math.cos(ang) * d, p.y + Math.sin(ang) * d * 0.8, (8 + rnd() * 4) * U);
        }
      };
      for (let i = 0; i < 9; i++) cluster(bez(P0, P1, P2, 0.12 + i * 0.09), 7 + Math.floor(rnd() * 5), 20);
      twigs.forEach((tw) => { for (let i = 0; i < 3; i++) cluster(bez(tw.a, tw.c, tw.b, 0.3 + i * 0.25), 5 + Math.floor(rnd() * 4), 14); });
      twigs.forEach((tw) => { const p = bez(tw.a, tw.c, tw.b, 0.95); leaf(p.x, p.y, tw.ang + (rnd() - 0.5) * 0.6, 80 * U, 9 * U); });
    };
    const paint = () => {
      ridges.forEach((cv) => {
        const cfg = RIDGE[+cv.dataset.ridge];
        cv.style.height = (cfg.frac * 100 + 14).toFixed(1) + "%";
        paintRidge(cv, cfg);
      });
      if (branch) { branch.style.height = "112%"; paintBranch(branch); }
    };
    let pw = 0;
    const repaint = () => { const w = sec.clientWidth; if (Math.abs(w - pw) < 2) return; pw = w; paint(); };
    repaint();
    if ("ResizeObserver" in window) { const ro = new ResizeObserver(repaint); ro.observe(sec); ctx.observers.push(ro); }
    if (REDUCED) return;
    ctx.inView(sec, (s) => {
      const r = sec.getBoundingClientRect();
      const p = clamp((s.vh - r.top) / (s.vh + r.height), 0, 1);
      for (const el of depthEls) {
        const d = +el.dataset.depth;
        el.style.transform = "translate3d(" + (-s.mx * 34 * d).toFixed(1) + "px," + ((0.5 - p) * 190 * d).toFixed(1) + "px,0)";
      }
    });
  }

  /* ---------------- how to order: phone demo ---------------- */
  function initPhone(ctx) {
    const phone = ctx.q('[data-nz="phone"]');
    const typed = ctx.q('[data-nz="typed"]'), caret = ctx.q('[data-nz="caret"]'), sent = ctx.q('[data-nz="sent"]');
    if (!phone || !typed) return;
    if (FINE && !REDUCED) {
      ctx.inView(phone, (s) => {
        phone.style.setProperty("--ry", (-16 + s.mx * 12).toFixed(2) + "deg");
        phone.style.setProperty("--rx", (8 - s.my * 7).toFixed(2) + "deg");
      });
    }
    if (REDUCED) return;
    const full = typed.textContent;
    if (phone.getBoundingClientRect().top < innerHeight) return;
    typed.textContent = "";
    sent.hidden = true;
    caret.hidden = false;
    const io = new IntersectionObserver((es) => {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      let i = 0;
      const tick = () => {
        i = Math.min(full.length, i + 1 + (Math.random() < 0.25 ? 1 : 0));
        typed.textContent = full.slice(0, i);
        if (i < full.length) setTimeout(tick, 26 + Math.random() * 38);
        else { caret.hidden = true; setTimeout(() => { sent.hidden = false; }, 380); }
      };
      setTimeout(tick, 500);
    }, { threshold: 0.45 });
    io.observe(phone);
    ctx.observers.push(io);
  }


  /* ---------------- shared FX (wordmark, cursor, word reveal, details, numbers) ---------------- */
  /* =====================================================
     NIROZA FX (shared by the website and the Shopify theme)
     dot-matrix wordmark · custom cursor · word reveal ·
     smooth details · count-up numbers · reading progress
     ===================================================== */
  const NZFX = (function () {
    const RM = matchMedia("(prefers-reduced-motion: reduce)");
    const HOVER = matchMedia("(hover: hover) and (pointer: fine)");
    const EASE = "cubic-bezier(.2,.75,.15,1)";

    /* ---------- 1. dot-matrix wordmark ---------- */
    function wordmark(canvas, opts) {
      const o = Object.assign({
        text: "Niroza",
        family: '"Eczar","Iowan Old Style","Palatino Linotype",Palatino,Georgia,serif',
        weight: 800, tracking: -0.045, rgb: "226,182,86",
        alphaTop: 0.95, alphaBottom: 0.22, fill: 0.94, debug: false
      }, opts || {});
      const reduced = RM.matches;
      const ctx = canvas.getContext("2d");
      const host = canvas.parentElement;
      let W = 0, H = 0, dpr = 1, dot = 3, R = 90, n = 0;
      let hx = new Float32Array(0), hy = hx, px = hx, py = hx, vx = hx, vy = hx, wk = hx, jc = hx, js = hx;
      let grad = null, raf = 0, last = 0, visible = true, dead = false, builtW = -1, timer = 0;
      let cx = -1e5, cy = -1e5, lx = -1e5, ly = -1e5, pvx = 0, pvy = 0, active = false, hasPoint = false;

      const font = (size) => o.weight + " " + size + "px " + o.family;
      function measure(g, size) {
        g.font = font(size);
        const chars = Array.from(o.text), ws = chars.map((ch) => g.measureText(ch).width);
        const track = o.tracking * size;
        return { chars, ws, track, total: ws.reduce((a, b) => a + b, 0) + track * Math.max(0, chars.length - 1) };
      }

      function build(force) {
        if (dead) return;
        const cssW = host.clientWidth;
        if (!cssW || (!force && cssW === builtW)) return;
        builtW = cssW;
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        const probe = document.createElement("canvas").getContext("2d");
        const size = (100 * cssW * o.fill) / Math.max(1, measure(probe, 100).total);
        const L = measure(probe, size);
        const m = probe.measureText(o.text);
        const asc = m.actualBoundingBoxAscent || size * 0.74, desc = m.actualBoundingBoxDescent || size * 0.04;
        const inkH = asc + desc, padT = Math.max(14, inkH * 0.1), padB = Math.max(18, inkH * 0.16), padY = padT;
        W = cssW; H = Math.ceil(inkH + padT + padB);
        canvas.style.height = H + "px";
        canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);

        const off = document.createElement("canvas");
        off.width = Math.ceil(W); off.height = H;
        const g = off.getContext("2d");
        g.font = font(size); g.fillStyle = "#000"; g.textBaseline = "alphabetic";
        let x = (W - L.total) / 2;
        L.chars.forEach((ch, i) => { g.fillText(ch, x, padY + asc); x += L.ws[i] + L.track; });
        const data = g.getImageData(0, 0, off.width, off.height).data;

        const pitch = Math.max(3.2, W / 225);
        dot = pitch * 0.58;
        R = Math.max(70, Math.min(190, W * 0.085));
        const cols = Math.floor(W / pitch), rows = Math.floor(H / pitch);
        const ox = (W - cols * pitch) / 2 + pitch / 2, oy = (H - rows * pitch) / 2 + pitch / 2;
        const X = [], Y = [];
        for (let r = 0; r < rows; r++) {
          const yy = oy + r * pitch, iy = Math.round(yy);
          if (iy < 0 || iy >= off.height) continue;
          for (let c = 0; c < cols; c++) {
            const xx = ox + c * pitch, ix = Math.round(xx);
            if (ix >= 0 && ix < off.width && data[(iy * off.width + ix) * 4 + 3] > 110) { X.push(xx); Y.push(yy); }
          }
        }
        n = X.length;
        hx = Float32Array.from(X); hy = Float32Array.from(Y);
        px = Float32Array.from(X); py = Float32Array.from(Y);
        vx = new Float32Array(n); vy = new Float32Array(n);
        wk = new Float32Array(n); jc = new Float32Array(n); js = new Float32Array(n);
        let seed = 7;
        const rnd = () => ((seed = (seed * 16807) % 2147483647) / 2147483647);
        for (let i = 0; i < n; i++) { const a = (rnd() - 0.5) * 1.5; wk[i] = 0.3 + rnd() * 1.1; jc[i] = Math.cos(a); js[i] = Math.sin(a); }
        grad = ctx.createLinearGradient(0, padY, 0, padY + inkH);
        grad.addColorStop(0, "rgba(" + o.rgb + "," + o.alphaTop + ")");
        grad.addColorStop(1, "rgba(" + o.rgb + "," + o.alphaBottom + ")");
        draw();
      }
      const rebuildSoon = (force) => { clearTimeout(timer); timer = setTimeout(() => build(force), 140); };

      function draw() {
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (!n) return;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.beginPath();
        const d = dot, h = d / 2;
        for (let i = 0; i < n; i++) ctx.rect(px[i] - h, py[i] - h, d, d);
        ctx.fillStyle = grad;
        ctx.fill();
      }

      function locate() {
        if (!hasPoint) { active = false; return; }
        const r = canvas.getBoundingClientRect();
        const nx = cx - r.left, ny = cy - r.top;
        active = nx > -R && nx < r.width + R && ny > -R && ny < r.height + R;
        lx = nx; ly = ny;
      }
      function point(x, y) {
        const r = canvas.getBoundingClientRect();
        const nx = x - r.left, ny = y - r.top;
        if (hasPoint && active) { pvx = pvx * 0.5 + (nx - lx) * 0.5; pvy = pvy * 0.5 + (ny - ly) * 0.5; }
        cx = x; cy = y; hasPoint = true;
        locate();
        if (active) wake();
      }

      function step(dt) {
        const f = Math.min(dt * 60, 3);
        const R2 = R * R, K = 0.0024 * f, damp = Math.pow(0.915, f), push = 3.1 * f, drag = 0.045 * f;
        let fast = false, off = false;
        for (let i = 0; i < n; i++) {
          let x = px[i], y = py[i], ux = vx[i], uy = vy[i];
          if (active) {
            const dx = x - lx, dy = y - ly, d2 = dx * dx + dy * dy;
            if (d2 < R2) {
              const d = Math.sqrt(d2) || 0.01, t = 1 - d / R, s = t * t * push * wk[i];
              const ex = dx / d, ey = dy / d, c = jc[i], sn = js[i];
              ux += (ex * c - ey * sn) * s + pvx * t * drag * wk[i];
              uy += (ex * sn + ey * c) * s + pvy * t * drag * wk[i];
            }
          }
          ux = (ux + (hx[i] - x) * K) * damp;
          uy = (uy + (hy[i] - y) * K) * damp;
          x += ux * f; y += uy * f;
          px[i] = x; py[i] = y; vx[i] = ux; vy[i] = uy;
          if (!fast && (ux > 0.03 || ux < -0.03 || uy > 0.03 || uy < -0.03)) fast = true;
          if (!off && (x - hx[i] > 0.2 || hx[i] - x > 0.2 || y - hy[i] > 0.2 || hy[i] - y > 0.2)) off = true;
        }
        pvx *= Math.pow(0.82, f); pvy *= Math.pow(0.82, f);
        return fast || (off && !active);
      }

      function tick(now) {
        raf = 0;
        if (dead || !visible) return;
        const dt = Math.min(0.05, Math.max(0.001, (now - last) / 1000));
        last = now;
        const moving = step(dt);
        draw();
        if (moving) raf = requestAnimationFrame(tick);
        else if (!active) { px.set(hx); py.set(hy); vx.fill(0); vy.fill(0); draw(); }
      }
      function wake() {
        if (reduced || dead || raf || !visible || !n) return;
        last = performance.now();
        raf = requestAnimationFrame(tick);
      }

      const onMove = (e) => { if (e.pointerType !== "touch") point(e.clientX, e.clientY); };
      const onTouch = (e) => { const t = e.touches && e.touches[0]; if (t) point(t.clientX, t.clientY); };
      const onEnd = () => { hasPoint = false; active = false; wake(); };
      const onScroll = () => { if (hasPoint) { locate(); if (active) wake(); } };
      const onLeave = (e) => { if (!e.relatedTarget) onEnd(); };

      let io = null, ro = null;
      if ("IntersectionObserver" in window) {
        io = new IntersectionObserver((es) => es.forEach((e) => { visible = e.isIntersecting; if (visible) wake(); }), { rootMargin: "120px 0px" });
        io.observe(canvas);
      }
      if ("ResizeObserver" in window) { ro = new ResizeObserver(() => rebuildSoon(false)); ro.observe(host); }
      else addEventListener("resize", () => rebuildSoon(false));
      if (!reduced) {
        addEventListener("pointermove", onMove, { passive: true });
        addEventListener("touchstart", onTouch, { passive: true });
        addEventListener("touchmove", onTouch, { passive: true });
        addEventListener("touchend", onEnd, { passive: true });
        addEventListener("touchcancel", onEnd, { passive: true });
        document.addEventListener("scroll", onScroll, { passive: true, capture: true });
        document.documentElement.addEventListener("mouseout", onLeave);
      }
      const onFonts = () => rebuildSoon(true);
      if (document.fonts) {
        if (document.fonts.load) Promise.race([document.fonts.load(font(100), o.text), new Promise((r) => setTimeout(r, 2500))]).then(onFonts, onFonts);
        if (document.fonts.addEventListener) document.fonts.addEventListener("loadingdone", onFonts);
      }
      build(true);
      if (o.debug) {
        canvas.__nzDebug = () => {
          let md = 0;
          for (let i = 0; i < n; i++) md = Math.max(md, Math.hypot(px[i] - hx[i], py[i] - hy[i]));
          return { count: n, maxDist: md, running: !!raf, radius: R, width: W, height: H };
        };
      }
      return {
        rebuild: () => build(true),
        destroy() {
          dead = true; cancelAnimationFrame(raf); clearTimeout(timer);
          if (io) io.disconnect(); if (ro) ro.disconnect();
          removeEventListener("pointermove", onMove); removeEventListener("touchstart", onTouch);
          removeEventListener("touchmove", onTouch); removeEventListener("touchend", onEnd); removeEventListener("touchcancel", onEnd);
          document.removeEventListener("scroll", onScroll, { capture: true });
          document.documentElement.removeEventListener("mouseout", onLeave);
          if (document.fonts && document.fonts.removeEventListener) document.fonts.removeEventListener("loadingdone", onFonts);
        }
      };
    }

    /* ---------- 2. custom cursor: ring + dot ---------- */
    function cursor(opts) {
      const o = opts || {}, P = o.prefix || "", de = document.documentElement;
      if (!HOVER.matches || RM.matches || de.__nzCursor) return;
      de.__nzCursor = 1;
      const within = o.within || (() => true);
      const ring = document.createElement("div"), dotEl = document.createElement("div");
      const inner = document.createElement("span"), label = document.createElement("span");
      ring.className = P + "cursor"; dotEl.className = P + "cursor-dot";
      inner.className = P + "cursor__ring"; label.className = P + "cursor__label";
      ring.setAttribute("aria-hidden", "true"); dotEl.setAttribute("aria-hidden", "true");
      inner.appendChild(label); ring.appendChild(inner);
      document.body.appendChild(ring); document.body.appendChild(dotEl);
      let x = 0, y = 0, rx = 0, ry = 0, raf = 0, last = 0, shown = false, first = true;
      const tog = (el, c, on) => el.classList.toggle(P + c, on);
      const HOT = "a,button,summary,label,select,[role=button],[data-cursor]";
      function show(on) {
        if (on === shown) return;
        shown = on;
        tog(ring, "is-on", on); tog(dotEl, "is-on", on); tog(de, "cursor-on", on);
      }
      function tick(now) {
        const dt = Math.min(0.05, Math.max(0.001, (now - last) / 1000));
        last = now;
        const k = 1 - Math.exp(-dt * 15);
        rx += (x - rx) * k; ry += (y - ry) * k;
        ring.style.transform = "translate3d(" + rx.toFixed(1) + "px," + ry.toFixed(1) + "px,0)";
        raf = Math.abs(x - rx) + Math.abs(y - ry) > 0.15 ? requestAnimationFrame(tick) : 0;
      }
      addEventListener("pointermove", (e) => {
        if (e.pointerType && e.pointerType !== "mouse") { show(false); return; }
        x = e.clientX; y = e.clientY;
        if (first) { rx = x; ry = y; first = false; }
        dotEl.style.transform = "translate3d(" + x + "px," + y + "px,0)";
        const t = e.target && e.target.closest ? e.target : null;
        const typing = !!(t && t.closest("input,textarea,select,[contenteditable],iframe"));
        show(!!t && !typing && within(t));
        const hot = t && t.closest(HOT);
        const text = hot && hot.getAttribute("data-cursor");
        tog(ring, "is-hover", !!hot && !text);
        tog(ring, "is-label", !!text);
        if (text && label.textContent !== text) label.textContent = text;
        const ink = !!(t && t.closest("[data-cursor-ink]"));
        tog(ring, "is-ink", ink); tog(dotEl, "is-ink", ink);
        if (!raf) { last = performance.now(); raf = requestAnimationFrame(tick); }
      }, { passive: true });
      addEventListener("pointerdown", () => tog(ring, "is-down", true), { passive: true });
      addEventListener("pointerup", () => tog(ring, "is-down", false), { passive: true });
      de.addEventListener("mouseout", (e) => { if (!e.relatedTarget) show(false); });
      addEventListener("blur", () => show(false));
    }

    /* ---------- 3. headings: words rise into view ---------- */
    function split(el, P) {
      if (el.__nzSplit) return;
      el.__nzSplit = 1;
      let i = 0;
      const walk = (node) => {
        Array.from(node.childNodes).forEach((ch) => {
          if (ch.nodeType === 3) {
            const parts = ch.nodeValue.split(/([ \t\n\r]+)/);
            const frag = document.createDocumentFragment();
            parts.forEach((part) => {
              if (!part) return;
              if (/^[ \t\n\r]+$/.test(part)) { frag.appendChild(document.createTextNode(" ")); return; }
              const w = document.createElement("span"), s = document.createElement("span");
              w.className = P + "w"; s.textContent = part; s.style.setProperty("--i", i++);
              w.appendChild(s); frag.appendChild(w);
            });
            node.replaceChild(frag, ch);
          } else if (ch.nodeType === 1 && ch.tagName !== "BR" && !ch.classList.contains(P + "w")) walk(ch);
        });
      };
      walk(el);
      el.classList.add(P + "split");
    }
    function headings(els, opts) {
      const P = (opts && opts.prefix) || "";
      const list = Array.from(els).filter((el) => !el.__nzSplit);
      list.forEach((el) => split(el, P));
      const show = (el) => el.classList.add(P + "in");
      if (RM.matches || !("IntersectionObserver" in window)) { list.forEach(show); return null; }
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
      }), { rootMargin: "0px 0px -7% 0px" });
      list.forEach((el) => io.observe(el));
      return io;
    }

    /* ---------- 4. smooth <details> (FAQ) ---------- */
    function details(list, opts) {
      const P = (opts && opts.prefix) || "";
      const all = Array.from(list);
      const panelOf = (d) => Array.from(d.children).find((c) => c.tagName !== "SUMMARY");
      function animate(d, open) {
        const body = panelOf(d);
        if (!body || RM.matches || !body.animate) { d.open = open; return; }
        if (d.__nzAnim) d.__nzAnim.cancel();
        const cs = getComputedStyle(body);
        const pt = cs.paddingTop, pb = cs.paddingBottom;
        body.style.overflow = "hidden";
        let anim;
        if (open) {
          d.classList.remove(P + "is-closing");
          d.open = true;
          const h = body.offsetHeight;
          anim = body.animate([{ height: "0px", paddingTop: "0px", paddingBottom: "0px", opacity: 0 },
                               { height: h + "px", paddingTop: pt, paddingBottom: pb, opacity: 1 }], { duration: 560, easing: EASE });
        } else {
          d.classList.add(P + "is-closing");
          const h = body.offsetHeight;
          anim = body.animate([{ height: h + "px", paddingTop: pt, paddingBottom: pb, opacity: 1 },
                               { height: "0px", paddingTop: "0px", paddingBottom: "0px", opacity: 0 }], { duration: 420, easing: EASE });
        }
        d.__nzAnim = anim;
        const done = () => {
          if (d.__nzAnim !== anim) return;
          d.__nzAnim = null;
          body.style.overflow = "";
          if (!open) { d.open = false; d.classList.remove(P + "is-closing"); }
        };
        anim.onfinish = done;
        anim.oncancel = () => { if (d.__nzAnim === anim) { d.__nzAnim = null; body.style.overflow = ""; } };
      }
      all.forEach((d) => {
        const s = Array.from(d.children).find((c) => c.tagName === "SUMMARY");
        if (!s || d.__nzDetails) return;
        d.__nzDetails = 1;
        s.addEventListener("click", (e) => {
          e.preventDefault();
          const opening = !d.open || d.classList.contains(P + "is-closing");
          if (opening) all.forEach((x) => { if (x !== d && x.open && !x.classList.contains(P + "is-closing")) animate(x, false); });
          animate(d, opening);
        });
      });
    }

    /* ---------- 5. numbers count up when seen ---------- */
    function countUp(els) {
      Array.from(els).forEach((el) => {
        if (el.__nzCount) return;
        el.__nzCount = 1;
        const text = el.textContent, m = text.match(/^(\D*)(\d[\d,]*)(.*)$/);
        if (!m || RM.matches || !("IntersectionObserver" in window)) return;
        const target = parseInt(m[2].replace(/,/g, ""), 10);
        if (!(target > 1)) return;
        const io = new IntersectionObserver((es) => es.forEach((e) => {
          if (!e.isIntersecting) return;
          io.disconnect();
          const t0 = performance.now(), dur = 1400 + Math.min(800, target * 2);
          const run = (now) => {
            const k = Math.min(1, (now - t0) / dur), v = Math.round(target * (1 - Math.pow(1 - k, 3)));
            el.textContent = m[1] + v + m[3];
            if (k < 1) requestAnimationFrame(run); else el.textContent = text;
          };
          requestAnimationFrame(run);
        }), { rootMargin: "0px 0px -10% 0px" });
        io.observe(el);
      });
    }

    /* ---------- 6. reading progress bar ---------- */
    function progress(bar, article) {
      if (!bar || !article || bar.__nzProgress) return;
      bar.__nzProgress = 1;
      let raf = 0;
      const update = () => {
        raf = 0;
        const r = article.getBoundingClientRect(), vh = innerHeight;
        const k = Math.min(1, Math.max(0, (vh * 0.35 - r.top) / Math.max(1, r.height - vh * 0.5)));
        bar.style.transform = "scaleX(" + k.toFixed(4) + ")";
      };
      const req = () => { if (!raf) raf = requestAnimationFrame(update); };
      document.addEventListener("scroll", req, { passive: true, capture: true });
      addEventListener("resize", req, { passive: true });
      update();
    }

    return { wordmark, cursor, headings, details, countUp, progress, reduced: () => RM.matches, hover: () => HOVER.matches };
  })();


  /* packs turn once on hover (or when scrolled into view on touch screens) */
  function bindHoverSpin(ctx, card) {
    if (card.__nzHoverSpin) return;
    card.__nzHoverSpin = 1;
    const canvas = card.querySelector("canvas[data-spin]:not([data-idle])");
    const pouch = card.querySelector("[data-pouch]:not([data-idle])");
    if (!canvas && !pouch) return;
    const spin = canvas ? canvas.__spin || new Spin(ctx, canvas) : null;
    if (REDUCED) return;
    let t0 = -1, busy = false;
    const ease = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);
    const task = (st) => {
      if (t0 < 0) t0 = st.t;
      const x = Math.min(1, (st.t - t0) / 1.7), phi = TAU * ease(x);
      if (spin) spin.draw(phi);
      if (pouch) setPouch(pouch, (phi * 180) / Math.PI);
      if (x >= 1) { busy = false; if (spin) spin.draw(0, true); if (pouch) setPouch(pouch, 0); ctx.stop(task); }
    };
    const go = () => { if (busy) return; busy = true; t0 = -1; ctx.start(task); };
    if (FINE) ctx.on(card, "pointerenter", go);
    else if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) go(); }), { threshold: 0.6 });
      io.observe(card);
      ctx.observers.push(io);
    }
  }

  function bindTiltSoft(ctx, el, amount) {
    if (!FINE || REDUCED || el.__nzTilt) return;
    el.__nzTilt = 1;
    ctx.on(el, "pointermove", (e) => {
      const r = el.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
      el.classList.add("nz-is-tilting");
      el.style.setProperty("--ry", ((px - 0.5) * amount).toFixed(2) + "deg");
      el.style.setProperty("--rx", ((0.5 - py) * amount * 0.7).toFixed(2) + "deg");
    });
    ctx.on(el, "pointerleave", () => {
      el.classList.remove("nz-is-tilting");
      el.style.setProperty("--rx", "0deg");
      el.style.setProperty("--ry", "0deg");
    });
  }

  function initFx(ctx) {
    const root = ctx.root;
    if (root.hasAttribute("data-nz-cursor")) NZFX.cursor({ prefix: "nz-", within: (t) => !!t.closest("[data-nz-cursor]") });
    const io = NZFX.headings(ctx.qa("[data-words], [data-split]"), { prefix: "nz-" });
    if (io) ctx.observers.push(io);
    const rise = ctx.qa(".nz-rise:not(.nz-in)");
    if (REDUCED || !("IntersectionObserver" in window)) rise.forEach((e) => e.classList.add("nz-in"));
    else {
      const rio = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("nz-in"); rio.unobserve(e.target); } }), { rootMargin: "0px 0px -5% 0px" });
      rise.forEach((el) => rio.observe(el));
      ctx.observers.push(rio);
    }
    ctx.qa("canvas[data-idle], [data-pouch][data-idle]").forEach((el, i) => {
      if (el.__nzIdle) return;
      el.__nzIdle = 1;
      const speed = parseFloat(el.dataset.idle) || 0.4;
      const spin = el.tagName === "CANVAS" ? el.__spin || new Spin(ctx, el) : null;
      if (REDUCED) return;
      const off = i * 1.7;
      ctx.inView(el, (st) => {
        if (spin) spin.draw(st.t * speed + off);
        else setPouch(el, Math.sin(st.t * Math.abs(speed) + off) * 62);
      });
    });
    ctx.qa(".nz-card, .nz-post-card").forEach((c) => bindHoverSpin(ctx, c));
    ctx.qa(".nz-post-card").forEach((c) => bindTiltSoft(ctx, c, 9));
    ctx.qa("[data-tilt-soft]").forEach((c) => bindTiltSoft(ctx, c, 10));
    NZFX.countUp(ctx.qa("[data-count]"));
    NZFX.details(ctx.qa(".nz-faq details"), { prefix: "nz-" });
    ctx.qa("canvas[data-wordmark]").forEach((c) => {
      try {
        const rgb = /^\d{1,3},\d{1,3},\d{1,3}$/.test(c.dataset.rgb || "") ? c.dataset.rgb : "226,182,86";
        // the section can pick its own font for the word (data-family / data-weight on the canvas)
        const opt = { text: c.dataset.text || "Niroza", rgb };
        if (c.dataset.family) opt.family = c.dataset.family;
        if (+c.dataset.weight) opt.weight = +c.dataset.weight;
        const wm = NZFX.wordmark(c, opt);
        ctx.observers.push({ disconnect: () => wm.destroy() });
      } catch (err) { console.error("[niroza]", err); }
    });
    NZFX.progress(ctx.q('[data-nz="progress"]'), ctx.q('[data-nz="article"]'));
    ctx.qa("[data-copy]").forEach((btn) => ctx.on(btn, "click", () => {
      const label = btn.querySelector("span") || btn;
      const text = btn.getAttribute("data-copy") || location.href;
      const done = () => { const old = label.textContent; label.textContent = btn.getAttribute("data-copied") || "Link copied"; setTimeout(() => { label.textContent = old; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, () => {});
    }));
  }


  /* ---------------- Niroza header: mobile menu, scroll state, cart count ---------------- */
  function initSiteHead(ctx) {
    const head = ctx.q('[data-nz="site-head"]');
    if (!head) return;
    const toggle = head.querySelector('[data-nz="menu-toggle"]');
    const panel = head.querySelector('[data-nz="menu-panel"]');
    const html = doc.documentElement;
    const setOpen = (open) => {
      if (!toggle || !panel) return;
      toggle.setAttribute("aria-expanded", String(open));
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      toggle.querySelector('[data-icon="open"]').hidden = open;
      toggle.querySelector('[data-icon="close"]').hidden = !open;
      panel.dataset.open = String(open);
      head.classList.toggle("nz-menu-open", open);
      html.classList.toggle("nz-lock", open);
      if (open) head.classList.remove("nz-is-hidden");
    };
    if (toggle && panel) {
      ctx.on(toggle, "click", () => setOpen(toggle.getAttribute("aria-expanded") !== "true"));
      ctx.on(panel, "click", (e) => { if (e.target.closest("a")) setOpen(false); });
      ctx.on(doc, "keydown", (e) => { if (e.key === "Escape" && panel.dataset.open === "true") { setOpen(false); toggle.focus(); } });
      ctx.on(window, "resize", () => { if (innerWidth > 1100 && panel.dataset.open === "true") setOpen(false); }, { passive: true });
    }

    const pw = doc.querySelector(".page-wrapper");
    const getY = () => Math.max(scrollY || 0, pw ? pw.scrollTop : 0);
    const hide = head.dataset.hide === "true" && !REDUCED;
    let lastY = getY(), ticking = false;
    const update = () => {
      ticking = false;
      const y = getY();
      head.classList.toggle("nz-is-scrolled", y > 24);
      if (hide && head.dataset.open !== "true" && !head.classList.contains("nz-menu-open")) {
        if (y > 520 && y > lastY + 6 && !head.contains(doc.activeElement)) head.classList.add("nz-is-hidden");
        else if (y < lastY - 6 || y <= 520) head.classList.remove("nz-is-hidden");
      }
      lastY = y;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    ctx.on(doc, "scroll", onScroll, { passive: true, capture: true });
    ctx.on(head, "focusin", () => head.classList.remove("nz-is-hidden"));
    update();

    const setHeights = () => {
      const h = head.offsetHeight;
      doc.body.style.setProperty("--header-height", h + "px");
      head.style.setProperty("--sh-total", h + "px");
    };
    setHeights();
    if ("ResizeObserver" in window) { const ro = new ResizeObserver(setHeights); ro.observe(head); ctx.observers.push(ro); }

    const counts = [...head.querySelectorAll('[data-nz="cart-count"]')];
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const refresh = () => fetch(root + "cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then((r) => r.json())
      .then((cart) => counts.forEach((el) => { el.textContent = cart.item_count; el.hidden = !cart.item_count; }))
      .catch(() => {});
    if (!window.__nzFetchWatch && typeof window.fetch === "function") {
      window.__nzFetchWatch = true;
      const original = window.fetch;
      window.fetch = function (input, init) {
        const url = typeof input === "string" ? input : (input && input.url) || "";
        const result = original.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          result.then(() => setTimeout(() => doc.dispatchEvent(new CustomEvent("nz:cart-changed")), 80), () => {});
        }
        return result;
      };
    }
    ctx.on(doc, "nz:cart-changed", refresh);
    ctx.on(window, "pageshow", (e) => { if (e.persisted) refresh(); });
  }

  /* ---------------- reveal on scroll (transform only) ---------------- */
  function initReveal(ctx) {
    const els = ctx.qa(".nz-rv");
    if (REDUCED || !("IntersectionObserver" in window)) { els.forEach((e) => e.classList.add("nz-in")); return; }
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add("nz-in"); io.unobserve(e.target); }
    }), { rootMargin: "0px 0px -6% 0px" });
    ctx.observers.push(io);
    els.forEach((el) => {
      if (el.getBoundingClientRect().top < innerHeight * 0.94) el.classList.add("nz-in");
      else io.observe(el);
    });
  }

  /* ---------------- boot ---------------- */
  const contexts = new Map();
  function mount(root) {
    if (!root || contexts.has(root)) return;
    let cfg = {};
    try { cfg = JSON.parse((root.querySelector("script[data-nz-config]") || {}).textContent || "{}"); } catch (e) {}
    const ctx = makeCtx(root);
    contexts.set(root, ctx);
    [initLinks, initSiteHead, initIntro, initFields, initTurntable, initMarquee, initTilt, initStory, initPeaks, initPhone, initReveal, initFx]
      .forEach((fn) => { try { fn(ctx, cfg); } catch (err) { console.error("[niroza]", err); } });
  }
  function unmount(root) {
    const ctx = contexts.get(root);
    if (ctx) { ctx.destroy(); contexts.delete(root); }
  }
  const mountAll = (scope) => (scope || doc).querySelectorAll("[data-nz-root]").forEach(mount);
  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", () => mountAll());
  else mountAll();
  doc.addEventListener("shopify:section:load", (e) => mountAll(e.target));
  doc.addEventListener("shopify:section:unload", (e) => e.target.querySelectorAll("[data-nz-root]").forEach(unmount));
})();
